import {localisedValue} from "utils"

const hierarchicalRegionsTransformer = response => {
  const {regions} = response
  const transformedData = hierarchicalOriginTransformerHelper(regions)
  return transformedData
}


const hierarchicalOriginTransformerHelper = (originsArray,id=9) => {
  const transformedArray = originsArray.map(item => {
    const { cities, ...remainingItems } = item
    return {
      id: remainingItems?.id,
      label: localisedValue({ object: remainingItems, key: "name" }),
      value: remainingItems?.regionId ? remainingItems?.id.toString()+"-c" : remainingItems?.id.toString(),
      ...(remainingItems?.regionId &&  { regionId: remainingItems?.regionId }),
      ...(cities?.length && { children: hierarchicalOriginTransformerHelper(cities , remainingItems?.id) }),
    }
  })
  return transformedArray
}

export default hierarchicalRegionsTransformer
